export default {
      id: "funds-usage",
      viewBox: "0 0 1182 1024",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#funds",
      toString: function () {
        return this.url;
      }
    }